(function() { window.GUID_69e2cdf1_92dd_46ae_a6ed_e86fe42af0c9 = { getGuid: function() { return "69e2cdf1-92dd-46ae-a6ed-e86fe42af0c9"; } }; })();
var CompuSport;
(function (CompuSport) {
    var ContextControls;
    (function (ContextControls) {
        class AddSchedulesDates {
            Show(groupId) {
                let me = this;
                let data = {
                    groupId: groupId
                };
                CompuSport.Ajax.Get(this.ActionUrl("Show"), data, function (response) {
                    me.refreshHtml(response);
                });
            }
            DiscoverUI() {
                let me = this;
                me.$container = $('#add-schedules-dates-container');
                me.$schedulesTableContainer = $('.schedules-table-container');
                me.groupId = me.$container.data('groupid');
                me.groupId = me.$container.data('groupid');
                me.$btnClose = me.$container.find('.btn-close-main');
                me.$startOn = me.$container.find('#startOn');
                me.$endOn = me.$container.find('#endOn');
                me.$nbTimesPerNight = me.$container.find('#nb-times-per-night');
                me.$btnReserveDates = me.$container.find('.btn-reserve-dates');
                me.$atTime = me.$container.find('#atTime');
                me.$matchLenghtMinutes = me.$container.find('#match-length-minutes');
                me.$startOn.CSDatePicker();
                me.$atTime.CSTimePicker();
                me.$atTime.data('context').EventToTrigger = "change";
            }
            BindEvents() {
                let me = this;
                me.$startOn.on('change', function () {
                    me.PreviewGeneratedDates();
                });
                me.$btnClose.on('click', function () {
                    me.$container.slideUp(250, function () {
                        me.$container.remove();
                    });
                });
                me.$btnReserveDates.on('click', function () {
                    me.$container.toggleClass('reservation-mode');
                });
                me.$container.on('click', '.btn-delete-date', function () {
                    let parentRow = $(this).closest('.date-row');
                    let data = {
                        groupid: me.groupId,
                        rowId: parentRow.data('rowid')
                    };
                    CompuSport.Ajax.Post(me.ActionUrl("DeleteUndeleteRow"), data, function (response) {
                        if (response != "") {
                            me.refreshHtml(response);
                        }
                    });
                }).on('click', '.ic-cs-lock,.ic-cs-unlock', function () {
                    let $this = $(this);
                    let $cell = $this.closest('td');
                    if (me.$container.hasClass('reservation-mode')) {
                        let cellData = me.GetCellData($this);
                        let askReservationDescription = !cellData.reserverd;
                        if (askReservationDescription) {
                            $cell.addClass('highlighted');
                            CompuSport.Controls.Popup.ShowInputDialogV2("Description", true, function (inputValue, accepted) {
                                if (accepted) {
                                    me.includeExcludeCell(cellData.rowId, cellData.flowBlockId, inputValue);
                                }
                                else {
                                    $cell.removeClass('highlighted');
                                }
                            });
                        }
                        else {
                            me.includeExcludeCell(cellData.rowId, cellData.flowBlockId, null);
                        }
                    }
                }).on('change keyup', '.nb-iterations,.endon-choice,.iteration-choice,#match-length-minutes,#nb-times-per-night,#atTime', function (e) {
                    let key = window.event ? e.keyCode : e.which;
                    if (e.type == "keyup" && key != 13) {
                        return;
                    }
                    me.PreviewGeneratedDates();
                }).on('click', '.nb-iterations', function () {
                    let radio = $(this).closest('.choice').find('input[type=radio]');
                    radio.prop('checked', true);
                }).on('click', '.description', function () {
                    if (me.$container.hasClass('reservation-mode')) {
                        let $this = $(this);
                        let descCellData = me.GetCellData($this);
                        CompuSport.Controls.Popup.ShowInputDialogV2("Description", true, function (inputValue, accepted) {
                            if (accepted) {
                                me.saveNewDescription(descCellData.rowId, descCellData.flowBlockId, inputValue);
                            }
                        }, descCellData.inputtedText);
                    }
                });
                this.$endOn.controlIsLoaded(function (dropDown) {
                    me.$endOnDropDown = dropDown;
                    dropDown.SelectionChange = function () {
                        me.PreviewGeneratedDates();
                    };
                });
            }
            GetCellData(element) {
                let cell = element.closest('td');
                let parentRow = cell.closest('.date-row');
                let inputtedText = cell.find('.inputted-text');
                let inputText = "";
                if (inputtedText.length > 0) {
                    inputText = inputtedText.html().trim();
                }
                return {
                    rowId: parentRow.data('rowid'),
                    flowBlockId: cell.data('fb'),
                    inputtedText: inputText,
                    reserverd: cell.hasClass('reserved')
                };
            }
            includeExcludeCell(rowId, flowBlockId, description) {
                let me = this;
                let data = {
                    groupId: me.groupId,
                    rowId: rowId,
                    flowBlockId: flowBlockId,
                    description: description
                };
                CompuSport.Ajax.Post(me.ActionUrl("IncludeExcludeCell"), data, function (response) {
                    me.refreshHtml(response);
                });
            }
            saveNewDescription(rowId, flowBlockId, description) {
                let me = this;
                let data = {
                    groupId: me.groupId,
                    rowId: rowId,
                    flowBlockId: flowBlockId,
                    description: description
                };
                CompuSport.Ajax.Post(me.ActionUrl("SaveNewDescription"), data, function (response) {
                    me.refreshHtml(response);
                });
            }
            PreviewGeneratedDates(deleteRowId) {
                let me = this;
                CompuSport.Lag(500, function () {
                    let generationParameters = {
                        groupId: me.groupId,
                        startOn: me.$startOn.val() + " " + me.$atTime.val(),
                        endOn: me.$endOnDropDown.GetSelectedItemValue("datestr"),
                        nbTimesPerNight: parseInt(me.$nbTimesPerNight.val()),
                        iterations: me.ExtractIterationsPerFlowBlock(),
                        matchLenghtMinutes: me.$matchLenghtMinutes.val(),
                        deleteRowId: deleteRowId
                    };
                    if (me.CheckIfParametersAreDifferents(generationParameters)) {
                        me.lastGenerationParameters = generationParameters;
                        CompuSport.Ajax.Post(me.ActionUrl("PreviewGeneratedDates"), generationParameters, function (response) {
                            me.refreshHtml(response);
                        });
                    }
                });
            }
            ExtractIterationsPerFlowBlock() {
                let inputs = this.$container.find('.nb-iterations');
                let result = '';
                $.each(inputs, function () {
                    let $this = $(this);
                    let parent = $this.closest('.flowblock-iterations-choices');
                    let iterationChoice = parent.find('.iteration-choice');
                    if (iterationChoice[0].checked == true) {
                        let value = $this.val();
                        let fb = $this.data('fb');
                        result += fb + ',' + value + '|';
                    }
                });
                return result;
            }
            CheckIfParametersAreDifferents(generationParameters) {
                return this.lastGenerationParameters == null ||
                    this.lastGenerationParameters.groupId != generationParameters.groupId ||
                    this.lastGenerationParameters.startOn != generationParameters.startOn ||
                    this.lastGenerationParameters.endOn != generationParameters.endOn ||
                    this.lastGenerationParameters.deleteRowId != generationParameters.deleteRowId ||
                    this.lastGenerationParameters.iterations != generationParameters.iterations ||
                    this.lastGenerationParameters.nbTimesPerNight != generationParameters.nbTimesPerNight ||
                    this.lastGenerationParameters.matchLenghtMinutes != generationParameters.matchLenghtMinutes;
            }
            refreshHtml(response) {
                let reservationMode = false;
                var tempScrollLeft = 0;
                var tempScrollTop = 0;
                if (this.$container != null && this.$container.length > 0) {
                    reservationMode = this.$container.hasClass('reservation-mode');
                    tempScrollLeft = this.$schedulesTableContainer.scrollLeft();
                    tempScrollTop = this.$schedulesTableContainer.scrollTop();
                    this.$container.remove();
                }
                CS.body.append(response);
                this.DiscoverUI();
                this.BindEvents();
                this.$schedulesTableContainer.scrollLeft(tempScrollLeft);
                this.$schedulesTableContainer.scrollTop(tempScrollTop);
                if (reservationMode) {
                    this.$container.addClass('reservation-mode');
                }
            }
            ActionUrl(url) {
                return (CSParameters.BaseUrl + "AddSchedulesDates/" + url + "/" + CSParameters.SportEventId.toString());
            }
        }
        ContextControls.AddSchedulesDates = AddSchedulesDates;
    })(ContextControls = CompuSport.ContextControls || (CompuSport.ContextControls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=AddSchedulesDates.js.map
